module.exports = __webpack_public_path__ + "static/ninja-f49222931cb50930ca7c68c1e506dc36.jpg";